import { render, staticRenderFns } from "./ResultLinks.vue?vue&type=template&id=3897ae63"
import script from "./ResultLinks.vue?vue&type=script&lang=js"
export * from "./ResultLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports